// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.successContainer.';

const WHATS_NEXT_DESCRIPTION = `${DOMAIN}whatsNextDescription`;

export { WHATS_NEXT_DESCRIPTION };
